import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  createNakshatr,
  getNakshatr,
  getNakshatrList,
  updateNakshatr,
} from "./api";

const initialState = {
  nakshtraListData: [],
  nakshtraData: [],
  fetchLoading: false,
  loading: false,
  error: null,
};

export const getNakshatrListAsync = createAsyncThunk(
  "nakshtra/getNakshatrList",
  async (_, thunkAPI) => {
    try {
      const data = await getNakshatrList();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch nakshtra",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const createNakshatrAsync = createAsyncThunk(
  "nakshtra/createNakshatr",
  async ({ createNakshatrValues }, thunkAPI) => {
    try {
      const data = await createNakshatr(createNakshatrValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to create nakshtra",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const getNakshatrAsync = createAsyncThunk(
  "nakshtra/getNakshatr",
  async (_, thunkAPI) => {
    try {
      const data = await getNakshatr();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch nakshtra",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const updateNakshatrAsync = createAsyncThunk(
  "nakshtra/updateNakshatr",
  async ({ updateNakshatrValues }, thunkAPI) => {
    try {
      const data = await updateNakshatr(updateNakshatrValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to update lagan",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

const nakshtraSlice = createSlice({
  name: "nakshtra",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNakshatrListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNakshatrListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.nakshtraListData = action.payload.data.results;
      })
      .addCase(getNakshatrListAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to fetch nakshtra";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(getNakshatrAsync.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getNakshatrAsync.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.nakshtraData = action.payload.data.results;
      })
      .addCase(getNakshatrAsync.rejected, (state, action) => {
        state.fetchLoading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch nakshtra";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(createNakshatrAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNakshatrAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.laganListData = action.payload.data.results;
      })
      .addCase(createNakshatrAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to create nakshtra";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(updateNakshatrAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateNakshatrAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.laganListData = action.payload.data.results;
      })
      .addCase(updateNakshatrAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to update nakshtra";
        state.error = errorMessage;
        toast.error(errorMessage);
      });
  },
});

export default nakshtraSlice.reducer;
